import React, { useState, useEffect } from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";

import { useTranslation } from "react-i18next";

import Swal from "sweetalert2";

import AuthUser from "../../../components/AuthUser";
import { toast, ToastContainer } from 'react-toastify';
import Spinner from "../../../components/Spinner";
import ZonaFilter from "../Administration/comercial/ZonaFilter";
import ZonaTable from "../Administration/comercial/ZonaTable";
import ZonaModal from "../../../components/Administration/comercial/ZonaModal";

const Zona = () => { 

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao, getMissao } = AuthUser();
  const [Zonas, setZonas] = useState([]);  

  const [filteredZonas, setfilteredZonas] = useState([]);

  const { t } = useTranslation();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  // Callback function to receive filtered users from UserFilter
  const handleFilterSubmit = (filteredZonas) => {

    console.log('received:');
    console.log(filteredZonas);
     
    setfilteredZonas(filteredZonas); 
  };


  const handleSubmissionSuccess = (Zonas) => {
    // Refresh acessos state or trigger any necessary actions
    setZonas(Zonas);    
  };

  const getZonas = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/zonas/'+getMissao()?.id);

      setZonas(res.data.zonas);

      setLoading(false);

    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  }; 
 

  useEffect(() => {

    const fetchData = async () => {
      try {
        // Chama a função assíncrona getUtilizador()
        await getZonas();

      } catch (error) {
        console.error('Erro ao obter Zonas:', error);
      }
    };

    // Chama a função fetchData() para iniciar o processo
    fetchData();
  }, []);

  if (verificarPermissao('CARGO', 'ver')) 
  if (loading) return (<><Spinner></Spinner></>); else return (
    <>
      (
      <>
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t('Zona')}
          title="Dashboard"
          subtitle={t('Zonas com que trabalhamos')}
          modal="#add_zona_modal"
          name={t('Add Zona')}
        />

        <ZonaFilter onFilterSubmit={handleFilterSubmit} />
        <ZonaTable zonas={filteredZonas.length > 0 ? filteredZonas : Zonas} />
        <ZonaModal onSubmissionSuccess={handleSubmissionSuccess} />

      </div>
    </div> </>
        ); </>
    );
  else
    return (<>
      <div className="page-wrapper cardhead">
        <div className="content ">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">SEM PERMISSÃO</h3>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">

              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"><i className="fa fa-times-circle text-danger"></i>&nbsp; OPERAÇÃO NÃO AUTORIZADA</h4>
                </div>
                <div className="card-body">
                  <p>
                    Esta operação não é autorizada para o seu nivel de acesso ao sistema, por favor contacte o administrador do sistema.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>)
};


export default Zona;
